import Vue from 'vue'

export default {
  index (status) {
    return Vue.http.get(window.API_URL + 'doctors/covid?status=' + status)
  },
  update (data) {
    return Vue.http.post(window.API_URL + 'doctors/covid/' + data.id, data.params)
  },
  create (data) {
    return Vue.http.post(window.API_URL + 'doctors/covid', data.params)
  }
}



// WEBPACK FOOTER //
// ./src/api/covid19.js